<script>
import { cloneDeep } from 'lodash-es';
import { mapActions } from 'vuex';
import NonDynamicTransportTripUpgradesRow from './NonDynamicTransportTripUpgradesRow';

export default {
  name: 'NonDynamicTransportTripUpgrades',
  components: {
    NonDynamicTransportTripUpgradesRow,
  },
  props: {
    tripId: {
      type: Number,
      default: null,
    },
    defaultTripUpgrade: {
      type: Object,
      required: true,
    },
    tripUpgrades: {
      type: Array,
      default: () => [],
    },
    tripUpgradeTypes: {
      type: Array,
      required: true,
    },
    tripUpgradesLoading: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      localTripUpgrades: [],
    };
  },
  created() {
    if (!this.tripUpgrades.length) {
      this.addTripUpgradeRow();
    } else {
      this.localTripUpgrades = [...this.tripUpgrades];
    }
  },
  watch: {
    stateTripUpgrades: {
      handler(value) {
        const localStateTripUpgrades = cloneDeep(value);
        this.localTripUpgrades = [...localStateTripUpgrades];
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions({
      syncTransportTripUpgrades: 'nonDynamicTransport/syncTransportTripUpgrades',
    }),
    addTripUpgradeRow() {
      this.localTripUpgrades.push(cloneDeep(this.defaultTripUpgrade));
    },
    removeTripUpgradeRow(index) {
      const tripUpgrades = [...this.localTripUpgrades];
      tripUpgrades.splice(index, 1);
      this.localTripUpgrades = [...tripUpgrades];
    },
    updateTripUpgradeValues(event) {
      const tripUpgrades = [...this.localTripUpgrades];
      tripUpgrades[event.index][event.attribute] = event.value;
      this.localTripUpgrades = [...tripUpgrades];
    },
    saveTripUpgrades() {
      const payload = { tripUpgrades: this.localTripUpgrades, tripId: this.tripId };
      this.syncTransportTripUpgrades(payload);
    },
  },
};
</script>

<template>
  <v-container class="pa-3">
    <v-layout class="mb-2">
      <h3>Upgrades</h3>
    </v-layout>
    <v-progress-linear v-if="tripUpgradesLoading" :indeterminate="true"/>
    <non-dynamic-transport-trip-upgrades-row
      v-else
      v-for="(tripUpgrade, index) in localTripUpgrades"
      :key="`non-dynamic-transport-upgrades-${index}`"
      :index="index"
      :trip-upgrade="tripUpgrade"
      :upgrade-types="tripUpgradeTypes"
      @add="addTripUpgradeRow"
      @remove="removeTripUpgradeRow"
      @update="updateTripUpgradeValues"
    />

    <v-layout>
      <v-flex>
        <v-btn
          class="right"
          color="success"
          @click="saveTripUpgrades"
        >
          {{ $t('buttons.save') }} upgrades
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>



// WEBPACK FOOTER //
// src/components/non-dynamic-transport/NonDynamicTransportTripUpgrades.vue